import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/', '/auth-redirect', '/sites', '/bind', '/register','/sign','/police-map'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/index' });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(() => {
          store.dispatch('GenerateRoutes').then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes); // 动态添加可访问路由表
            next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
          });
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Message.error(err);
            next({ path: '/' });
          });
        });
      } else {
        next();
      }
    }
  } else {
    // 没有token
    const loginType = localStorage.getItem('loginType');
    const url = location.origin + location.pathname;
    const isMap = url === 'https://sos.didisos.cn/datav/yancheng_bxhyxh.html'
    if (whiteList.indexOf(to.path) !== -1 || loginType === '3193' || isMap) {
      // 在免登录白名单，直接进入
      next();
    } else {
      console.log(to);
      const type = to.query.loginType;
      if (type) {
        localStorage.setItem('loginType', to.query.loginType);
      }
      if (from.path === '/' && loginType !== '3193' && !isMap) {
        next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      }else {
        next({ path: '/' });
      }
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
